import {forceUpdate} from "@stencil/core";

/**
 * Initialize the MutationObserver with its callback.
 * The idea is to filter mutations in order not to trigger extra-renders, only those needed.
 * @param {HTMLJoySelectElement} root - root element where we need to plug our MutationObserver in.
 */
function setMutationObserver(root: HTMLJoySelectElement): MutationObserver {
    const observer = new MutationObserver((mutations) => {
        for (const mutation of mutations) {
            if (mutation.type === 'childList') {
                [...mutation.addedNodes, ...mutation.removedNodes]
                    .forEach((node) => {
                        if (node.nodeName === 'JOY-OPTION') {
                            return forceUpdate(root);
                        }
                    });
            } else {
                /**
                 * For attributes, characterData, we check the same thing
                 */
                if (isParentNodeJoyOption(mutation)) {
                    return forceUpdate(root);
                }
            }

            return;
        }
    });

    return observer;
}

function isParentNodeJoyOption(mutation: MutationRecord): boolean {
    return mutation.target.parentNode?.nodeName === 'JOY-OPTION';
}

export function initObserver(root: HTMLJoySelectElement): MutationObserver {
    const observer = setMutationObserver(root);
    observer.observe(root, {
        attributes: true,
        childList: true,
        subtree: true,
        characterData: true
    });

    return observer;
}